<template>
    <transition name="layout-fade">
        <loader v-if="loading"/>
        <v-layout wrap column class="layout-add layout-add--max_width" v-else>
            <v-toolbar text class="v-toolbar--custom">
                <v-toolbar-title>Просмотр статистики для пользователей</v-toolbar-title>
                <v-spacer/>
                <v-btn icon :loading="loading" :disabled="loading" @click="closeLayout">
                    <v-icon>close</v-icon>
                    <span slot="loader" class="custom-loader">
        				<v-icon light>cached</v-icon>
      				</span>
                </v-btn>
            </v-toolbar>

            <v-form class="form-add">
                <v-layout>
                    <v-flex xs5>
                        <sex :data-sex="customer"/>
                    </v-flex>

                    <v-spacer/>

                    <v-flex xs5>
                        <device :data-device="customer"/>
                    </v-flex>
                </v-layout>

                <v-layout class="mt-10 justify-space-between">
                    <v-flex v-if="register" xs5>
                        <v-simple-table
                            :fixed-header="true"
                        >
                            <template v-slot:default>
                                <thead>
                                    <tr>
                                        <th class="text-left">Количество новых пользователей</th>
                                        <th class="text-left">Дата</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    <tr>
                                        <td>{{ register.today }}</td>
                                        <td>За сегодня</td>
                                    </tr>

                                    <tr>
                                        <td>{{ register.last_week }}</td>
                                        <td>За неделю</td>
                                    </tr>

                                    <tr>
                                        <td>{{ register.last_month }}</td>
                                        <td>За месяц</td>
                                    </tr>

                                    <tr>
                                        <td>{{ register.all }}</td>
                                        <td>За все время</td>
                                    </tr>
                                </tbody>
                            </template>
                        </v-simple-table>
                    </v-flex>

                    <v-flex v-if="telegram_register" xs5>
                        <v-simple-table
                            :fixed-header="true"
                        >
                            <template v-slot:default>
                                <thead>
                                    <tr>
                                        <th class="text-left">Дата</th>
                                        <th class="text-left">Количество новых пользователей телеграма</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    <tr>
                                        <td>{{ telegram_register.today }}</td>
                                        <td>За сегодня</td>
                                    </tr>

                                    <tr>
                                        <td>{{ telegram_register.last_week }}</td>
                                        <td>За неделю</td>
                                    </tr>

                                    <tr>
                                        <td>{{ telegram_register.last_month }}</td>
                                        <td>За месяц</td>
                                    </tr>

                                    <tr>
                                        <td>{{ telegram_register.all }}</td>
                                        <td>За все время</td>
                                    </tr>
                                </tbody>
                            </template>
                        </v-simple-table>
                    </v-flex>
                </v-layout>

                <v-flex class="mt-10" xs12>
                    <v-layout>
                        <v-subheader class="headline pa-0">Другое</v-subheader>
                    </v-layout>

                    <v-layout>
                        <v-flex xs5>
                            <v-subheader class="pa-0">Текущее кол-во бонусов у пользователей:</v-subheader>
                            <b>{{ customer.bonus | formatPrice }} баллов</b>
                        </v-flex>
                    </v-layout>
                </v-flex>
            </v-form>
        </v-layout>
    </transition>
</template>

<script>
    import Statistic from '../../../api/statistic'
    import Loader from '../../../components/Loader/Layout'
    import Sex from './Components/Customer/Sex'
    import Device from './Components/Customer/Device'

    export default {
        name: 'statisticCustomer',
        components: {
            Loader,
            Sex,
            Device
        },
        data: () => ({
            loading: false,
            customer: {
                all: 0,
                active: 0,
                not_active: 0,
                man: 0,
                woman: 0,
                bonus: 0,
                all_devices: 0,
                ios: 0,
                android: 0,
                register: {},
                telegram_register: {},
            }
        }),

        computed: {
            register() {
                return this.customer.register;
            },

            telegram_register() {
                return this.customer.telegram_register;
            },
        },

        mounted () {
            this.loading = true

            Statistic
                .getCustomerStat()
                .then(response => this.customer = response.data.data)
                .catch(error => new Error(error))
                .finally(() => this.loading = false)
        },
        created () {
            this.setHeaderTitle('Клиенты')
        },
        methods: {
            closeLayout () {
                this.$router.push({ name: 'headBlankIndex' })
            }
        }
    }
</script>
